import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=1a0afa14"
import script from "./Formula.vue?vue&type=script&lang=js"
export * from "./Formula.vue?vue&type=script&lang=js"
import style0 from "./Formula.vue?vue&type=style&index=0&id=1a0afa14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports